import { Button } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

/**
 * @param {import("@mantine/core").ButtonProps & { submitIcon?: import("react").ReactNode, submitText?: string }} props
 */
export default function SaveActionButton({ submitIcon, submitText, ...props }) {
	return (
		<Button type="submit" leftSection={submitIcon ?? <IconCheck />} {...props}>
			{submitText ?? "Guardar"}
		</Button>
	);
}
